@if (show()) {
<div class="alert-pop-up" (click)="close($event)">
	<div class="alert-pop-up-in">
		<div class="google-signIn">
			<button (click)="loginViaGoogle()" type="button">
				<img style="vertical-align: text-bottom;" width="21" src="assets/images/google-sign.png" alt="SignInWithGoogle" />
				<span style="margin-left: 8px">Sign in with Google</span>
			</button>
			<button (click)="loginViaApple()" type="button" style="margin-top: 10px;">
				<img style="vertical-align: text-bottom;" width="24" src="assets/images/apple-sign.png" alt="SignInWithApple" />
				<span style="margin-left: 7px">Sign in with Apple</span>
			</button>
		</div>
		<div class="line-hr">
			<div>or</div>
		</div>
		<h4>
			Enter your password
		</h4>
		<form class="loginBox-form" (submit)="login()">
			<mat-form-field class="full-width" appearance="outline">
				<input matInput type="password" [formControl]="passwordFormControl" [errorStateMatcher]="matcher" placeholder="Password">
				<mat-icon matSuffix style="padding: 0 !important;">lock_outline</mat-icon>
				@if (passwordFormControl.hasError('required')) {
				<mat-error>
					Password is required
				</mat-error>
				}
			</mat-form-field>

			@if (incorrect()) {
			<span class="text-danger text-center">
				Incorrect password
			</span>
			}

			<div style="display: flex; justify-content: center">
				<div style="margin-right: 10px;">
					<button type="submit" class="btn-secondary" style="min-width: 120px !important">Proceed</button>
				</div>
				<div style="margin-left: 10px;">
					<button type="button" class="btn-gray" (click)="show.set(false)" style="min-width: 120px !important">Cancel</button>
				</div>
			</div>
		</form>

		@if (loading()) {
		<div class="loader-box">
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
			<div class="circle"></div>
		</div>
		}
	</div>
</div>
}
